import { Box, Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContacts } from 'store/global/actions';
import { getContactsSelector } from 'store/global/selectors';
import { getLocale } from 'store/LanguageProvider/selectors';
import Section from '../Section';
import EMERGENCY from '../contants';

const Body = () => {
  const dispatch = useDispatch();
  const lang = useSelector(getLocale);
  const { contacts, isLoading } = useSelector(getContactsSelector);

  useEffect(() => {
    if (lang) {
      dispatch(getContacts(lang));
    }
  }, [dispatch, lang]);

  return (
    <Box padding={4}>
      <Grid container alignItems="center" justify="center">
        <Grid item xs={6}>
          {!isLoading && contacts.length > 0 && (
            <Grid container direction="column">
              {contacts.map((section, index) => (
                <Grid item key={index}>
                  <Section body={section.body} type={section.type} />
                </Grid>
              ))}
              <Grid item>
                <Section body={EMERGENCY.body} type={EMERGENCY.type} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default Body;
